module.exports = __webpack_public_path__ + "static/media/logo-sm.de4b7e72.png";